import { useContext, useEffect } from "react";
import { NavigationContext } from "../contexts/NavigationContext";

const useMenuSecondary = (menuData) => {
  const { updateSecondaryMenu } = useContext(NavigationContext);

  useEffect(() => {
    updateSecondaryMenu(menuData);

    // Cleanup function to reset the secondary menu is now unessasary, as we're memoing menu items 
    // return () => {
    //   updateSecondaryMenu({ title: "", items: [] });
    // };
  }, [menuData, updateSecondaryMenu]);
};

export default useMenuSecondary;
